// extracted by mini-css-extract-plugin
export default {"wrapper":"MyAccountModal_wrapper__fHk36","verifyIdentityWrapper":"MyAccountModal_verifyIdentityWrapper__yQm5a"};